import { render, staticRenderFns } from "./CreatedLabel.vue?vue&type=template&id=0106435f"
import script from "./CreatedLabel.vue?vue&type=script&lang=js"
export * from "./CreatedLabel.vue?vue&type=script&lang=js"
import style0 from "./CreatedLabel.vue?vue&type=style&index=0&id=0106435f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports